import { Link } from 'react-router-dom';
import { PlusIcon, VideoIcon } from 'lucide-react';
import { PageHeader } from '../ui/PageHeader';
import { OfferTabs } from './OfferTabs';
import { Badge } from '../ui/Badge';
import { useAdmin } from '../AdminContext';
import { btnPrimary, listBox, rowLink } from '../ui/styles';
import { kuurLabel, treatmentDuration, treatmentPrice } from '../../utils/catalog';
import { treatmentCategories } from '../../data/treatments';

/** Alle behandelingen, per categorie. */
export function Treatments() {
  const {
    catalog
  } = useAdmin();
  return <div data-id="element-966" data-mp="19wg8u8a39cfi">
      <PageHeader title="Behandelingen" description="Wat je in de salon (en online) aanbiedt. Prijs en duur verschijnen op de salonpagina en in de afsprakenlade." actions={<Link to="/be/behandelingen/nieuw" className={btnPrimary} data-id="element-968" data-mp="1ixecgpgm7hxk">
            <PlusIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-969" data-mp="2z7qhawudad3z" />
            Nieuwe behandeling
          </Link>} data-id="element-967" data-mp="19wq162ilvvod" />
      <OfferTabs data-id="element-970" data-mp="2dmzmep2punwq" />

      <div className="space-y-8" data-id="element-971" data-mp="2dniu7cynjvx1">
        {treatmentCategories.map((cat, i) => {
        const items = catalog.treatments.filter(t => t.category === cat);
        if (!items.length) return null;
        // Categorienamen bevatten spaties en streepjes; een index is een veilig id.
        const headingId = `treatment-cat-${i}`;
        return <section key={cat} aria-labelledby={headingId} data-id="element-972" data-mp="2shnpjwkn9a96" data-mpi={i}>
              <h2 id={headingId} className="mb-3 font-display text-[18px] text-ink" data-id="element-973" data-mp="1uxkkytj4bwrt">
                {cat} <span className="font-sans text-[13px] text-muted" data-id="element-974" data-mp="1zwe0erhytxum">· {items.length}</span>
              </h2>
              <ul className={listBox} data-id="element-975" data-mp="24tnpg61g07hx">
                {items.map(t => <li key={t.slug} data-id="element-976" data-mp="29le0yfc491ax">
                    <Link to={`/be/behandelingen/${t.slug}`} className={`${rowLink} flex-wrap gap-y-1`} data-id="element-977" data-mp="29mgrgm5j11qb">
                      <span className="min-w-0 flex-1" data-id="element-978" data-mp="1c3nrkr5czuok">
                        <span className="flex items-center gap-2 text-[15px] text-ink" data-id="element-979" data-mp="1h41s7o4ms2ck">
                          <span className="truncate" data-id="element-980" data-mp="193nf18xeh3m5">{t.name}</span>
                          {t.signature && <Badge tone="soft" data-id="element-981" data-mp="145c0wm02o6y4">Signature</Badge>}
                          {t.online && <>
                              <VideoIcon className="h-3.5 w-3.5 shrink-0 text-muted" strokeWidth={1.75} aria-hidden="true" data-id="element-982" data-mp="1isndmr7zpwzt" />
                              <span className="sr-only" data-id="element-983" data-mp="1dvnez1dgzwiq">Online</span>
                            </>}
                        </span>
                        <span className="block truncate text-[13px] text-muted" data-id="element-984" data-mp="l6zu36wmv95p">{t.tagline}</span>
                      </span>
                      <span className="text-[13px] tabular-nums text-muted" data-id="element-985" data-mp="1051xnh3nzumy">{treatmentDuration(t)}</span>
                      <span className="text-[14px] tabular-nums text-ink sm:w-40 sm:text-right" data-id="element-986" data-mp="v2t4ajmvqqkb">
                        {treatmentPrice(t)}
                        {t.kuur && <span className="block text-[12px] text-muted" data-id="element-987" data-mp="26k2iorr5iser">{kuurLabel(t)}</span>}
                      </span>
                    </Link>
                  </li>)}
              </ul>
            </section>;
      })}
      </div>
    </div>;
}